var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.24974747,11 L4.24974747,11 L4.24974747,9 L7.24974747,9 L7.24974747,2 L9.24974747,2 L9.24974747,11 Z",
    transform: "rotate(45 6.75 6.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkCircle);
export default __webpack_public_path__ + "static/media/icon-checkmark-circle.ea4bd68ee48c058c1dc9e575134a8122.svg";
export { ForwardRef as ReactComponent };